import { useState } from "react";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import { Href } from "../../../Constants/Constants";
import { DashBoardCommonDropdown } from "../../../Types/CommonComponentsType";

export const CommonDropdown:React.FC<DashBoardCommonDropdown> = ({ days, dropdownTitle, dropdownClass }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);

  return (
    <Dropdown className="icon-dropdown" isOpen={dropdownOpen} toggle={toggle}>
      <DropdownToggle color="transparent" caret={dropdownTitle ? true : false} className={dropdownClass}>
        {dropdownTitle ? dropdownTitle : <i className="icon-more-alt"></i>}
      </DropdownToggle>
      <DropdownMenu end>
        <DropdownItem tag="a" href={Href}>{`${days ? "Today" : "Weekly"}`}</DropdownItem>
        <DropdownItem tag="a" href={Href}>{`${days ? "Tomorrow" : "Monthly"}`}</DropdownItem>
        <DropdownItem tag="a" href={Href}>{`${days ? "Yesterday" : "Yearly"}`}</DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
};
